exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\nbutton {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/functional_components/product-list/product-buttons/product-buttons.component.css
// module id = 372
// module chunks = 1